export default __webpack_public_path__ + "91c46dd13ab845d0febdb4b649533f3e.png";